import { render, staticRenderFns } from "./productStockManage.vue?vue&type=template&id=3002bf7f&scoped=true"
import script from "./productStockManage.vue?vue&type=script&lang=js"
export * from "./productStockManage.vue?vue&type=script&lang=js"
import style0 from "./productStockManage.vue?vue&type=style&index=0&id=3002bf7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002bf7f",
  null
  
)

export default component.exports